import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { downloadFileFromResponse } from '@cbridge-utils/file';
import { catchApiError, IClientApiDependencySegment } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { SymbolClientAction } from '../symbolClient.action';
import { filterExportSortFields } from '../_helpers/filterExportSortFields';

type IDependencies = IClientApiDependencySegment;

export const exportClientSymbolsEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(SymbolClientAction.exportFile.started),
  mergeMap((params) => {
    const {
      nodeId, serverId, showUnmapped: includeUnmapped, sort: sortArray, search, streamId, symbolGroup,
    } = params;
    const sort = sortArray?.length
      ? filterExportSortFields(sortArray).join(',') || undefined
      : undefined;

    const request$ = serverId
      ? dependencies.api.exportServerClientSymbols({
        serverId, includeUnmapped, sort, search, streamId, symbolGroup,
      })
      : dependencies.api.exportNodeClientSymbols({
        nodeId, includeUnmapped, sort, search, streamId, symbolGroup,
      });

    return request$.pipe(
      mergeMap((response) => {
        downloadFileFromResponse(response);
        return [];
      }),
      catchApiError((error) => {
        return [
          SymbolClientAction.exportFile.failed({ params, error }),
          createApiErrorNotification(error),
        ];
      }),
    );
  }),
);
